import react, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Menu from "../../../Layout/Menu/Menu";
import { Navigation, NavigationMobile } from "../../Navigation/Menu";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Puff } from "react-loading-icons";
import BillingNavigation from "../BillingNavigation";
import Accordion from "react-bootstrap/Accordion";
import NavBar from "../../../../components/NavBar";

const BillingFaq = () => {
  let params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    document.title = "Transactions | Nightspot Dashboard";
  }, []);

  const InsideLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <Puff stroke="#333" height="5em" width="5em" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          Loading...
        </div>
      </div>
    );
  };

  return (
    <div>
      <NavBar>
        <div className="row">
          <div className="col-sm-12 dashboard-content">
            {isLoading ? (
              <InsideLoading />
            ) : (
              <>
                <div className="row">
                  <div className="col-8">
                    <h2 className="dashboard-h2">FAQ</h2>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <nav>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="/my/dashboard">
                            <i className="fa-solid fa-home"></i>
                          </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/my/nightspots">Lista Nightspots</Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to={`/my/billing/manager/${params.id_venues}`}>
                            Gestão de subscrição
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">FAQ</li>
                      </ol>
                    </nav>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12">
                    <div className="row mt-3">
                      <div className="col-5 col-sm-3 ">
                        <BillingNavigation tab="faq" />
                      </div>
                      <div className="col-7 col-sm-9 container">
                        <div
                          className="p-3 h-100"
                          style={{
                            backgroundColor: " #0a1116",
                            borderRadius: "8px",
                          }}
                        >
                          <div className="row">
                            <div className="col-12">
                              <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                  <Accordion.Header>
                                    Posso alterar o meu plano?
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    <strong>Sim!</strong> É possivel alterar o
                                    plano a qualquer altura sem perder os
                                    beneficios já contratados.
                                  </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item>
                                  <Accordion.Header>
                                    Quando é que o plano fica ativo?
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    Assim que o pagamento seja validado o plano
                                    fica automaticamente ativo.
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </NavBar>
      {/* <ToastContainer /> */}
    </div>
  );
};

export default BillingFaq;
